var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VanBtn',{staticClass:"dir-btn",attrs:{"round":""}},[_c('img',{attrs:{"src":require("./img/dir.png"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"index"},[_vm._v("目录")])])}
var staticRenderFns = []

export { render, staticRenderFns }